<template>
  <div v-if="ownerCurrentGame" class="pravo">
    <PravoTop
      Image="editProducts"
      :Header="`Lobby - ${ownerCurrentGame.name}`"
    />

    <button
      class="pravo__startGame"
      @click="startGame"
      :disabled="isTeamsConnected()"
      :class="isTeamsConnectedClass()"
    >
      Start the game
    </button>
    <!--
    <button
      class="pravo__startGame"
      @click="activateGame"
      v-show="!this.ownerCurrentGame.active"
    >
      Activate the game
    </button> -->

    <div class="pravo__obsah">
      <div class="pravo__buttons">
        <GoBack
          href="/gameManager/allGames"
          icon="gameOverview"
          text="Back to all games"
        />
      </div>
      <div
        class="pravo__gameCode"
        v-if="(ownerCurrentGame.accessCode || joinedGame.accessCode || accessCode != '') && (ownerCurrentGame.isPrivate || joinedGame.isPrivate) "
      >
        <div class="pravo__gameCode__left">Game code</div>
        <input
          class="pravo__gameCode__input"
          id="code"
          :value="
            ownerCurrentGame.accessCode ||
            joinedGame.accessCode ||
            accessCode ||
            'Access code'
          "
          readonly
        />
        <button class="pravo__gameCode__copy" @click="copyCode()"></button>
        <div class="clearfix"></div>
      </div>

      <!--            <div class="grid">-->
      <!--              <div class="tabulka fitContent">-->
      <!--                <div class="tabulka__top">-->
      <!--                  <div class="tabulka__top__nadpis">New team</div>-->
      <!--                </div>-->

      <!--                <div class="tabulka__body">-->
      <!--                  <div class="tabulka__body__inlineHeadline">-->
      <!--                    Team name:-->
      <!--                  </div>-->
      <!--                  <input-->
      <!--                    type="text"-->
      <!--                    class="tabulka__body__inlineInput"-->
      <!--                    v-model="newTeamName"-->
      <!--                  >-->
      <!--                  <div-->
      <!--                    class="tabulka__body__inlineButton"-->
      <!--                    @click="addTeam()"-->
      <!--                  >-->
      <!--                    Create new team-->
      <!--                  </div>-->

      <!--                  <div class="clearfix"></div>-->
      <!--                </div>-->

      <!--              </div>-->

      <!--            </div>-->

      <div v-if="lobbyPlayersWithoutTeam.length" class="grid">
        <div class="tabulka full">
          <div class="tabulka__top">
            <div class="tabulka__top__nadpis">Players without a team</div>
          </div>
          <div class="tabulka__body">
            <div class="tabulka__body__full">
              <span
                v-for="player in uniqUsers"
                :key="`LobbyPlayer-${player.id}`"
                class="gray"
                style="margin-right: 10px; display: inline-block"
              >
                <div class="tabulka__body__userProfileIcon"></div>
                {{ player.username }}
              </span>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div class="grid">
        <TeamPlayers
          v-for="team in lobbyTeams"
          :key="team.id"
          :name="team.name"
          :sourceData="team.players"
          @delete="deleteTeam(team)"
          @delete-player="deletePlayer"
          @kick-player="kickPlayer"
        />
      </div>
      <!--      <Teams/>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GoBack from "@/components/game/pravo/GoBack.vue";
import PravoTop from "@/components/game/pravo/PravoTop.vue";
import TeamPlayers from "@/components/gameManager/TeamPlayers.vue";
import _ from "lodash";

export default {
  name: "gameManagerLobby",
  components: {
    GoBack,
    PravoTop,
    TeamPlayers,
  },
  data: function () {
    return {
      activated: false,
      accessCode: ""
    };
  },
  computed: {
    uniqUsers() {
      return _.uniqBy(this.lobbyPlayersWithoutTeam, "id");
    },
    ...mapGetters([
      "ownerCurrentGame",
      "lobbyTeams",
      "lobbyPlayersWithoutTeam",
      "me",
      "joinedGame",
    ]),
  },
  async created() {
    if (!this.ownerCurrentGame) {
      this.$router.push({ name: "GameManager.allGames" });
      return;
    }
    await this.$store.dispatch("fetchMe");
    var lobby = await this.$store.dispatch("fetchLobby");
    this.accessCode = lobby.game.accessCode
  },
  methods: {
    copyCode() {
      let copyText = document.querySelector("#code");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      this.$toast.success(this.$t("messages.game-lobby.saved-code"));
    },
    isTeamsConnected() {
      if (this.lobbyTeams.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    isTeamsConnectedClass() {
      if (this.lobbyTeams.length == 0) {
        return "disabled_startGame";
      }
    },
    //     addTeam: function () {
    //     var newId;
    // if (this.newTeamName == '')
    //   return
    //
    // if (!this.teams.length) {
    //   newId = 0;
    // } else {
    //   newId = this.teams[this.teams.length - 1].id + 1;
    // }
    // this.teams.push({
    //   id: newId,
    //   name: this.newTeamName,
    //   players: []
    // });
    // this.newTeamName = ''
    // },
    async deleteTeam(team) {
      await this.$store.dispatch("deleteTeam", team.id);
    },
    async deletePlayer(player) {
      await this.$store.dispatch("removeUserFromTeam", player.id);
    },
    async kickPlayer(player) {
      await this.$store.dispatch("removeUserFromLobby", player.id);
    },
    async startGame() {
      await this.$store.dispatch("startGame");
      // this.$router.push({name: 'GameManager.game.settings'})
    },
    async activateGame() {
      await this.$store.dispatch("activateGame");
      this.ownerCurrentGame.active = true;
      this.activated = true;
      // this.$router.push({name: 'GameManager.game.settings'})
    },
  },
};
</script>

<style>
</style>
